import React from 'react';
import I18n from 'i18n-js';
import gql from 'graphql-tag';
import ShopTaxPoliciesInternal from './discovery/shops/shop_tax_policies_internal';
import { RCToggledContent } from '@reverbdotcom/cadence/components';
import { Item2ShopTaxPoliciesData } from '../schemas/rql';

interface Props {
  listing: Item2ShopTaxPoliciesData.Fragment;
}

export const Item2ShopTaxPoliciesFragment = gql`
  fragment Item2ShopTaxPoliciesData on Listing {
    _id
    taxPolicies {
      displayRate
      displayLocation
      policyType
    }
  }
`;

export default function Item2ShopTaxPolicies({ listing }: Props) {
  return (
    <div
      className="plr-1 bdb-1 bd-primary"
    >
      <RCToggledContent
        heading={I18n.t('discovery.shopTaxPolicies.taxPolicies')}
        small
        id="shop-tax-policies"
      >
        <ShopTaxPoliciesInternal taxPolicies={listing.taxPolicies} />
      </RCToggledContent>
    </div>
  );
}
